<template>
    <div>
        <el-tree
            v-if="popover === false"
            ref="tree"
            highlight-current
            node-key="id"
            :current-node-key="selectNodeId"
            :default-expanded-keys="idExpandedArr"
            :expand-on-click-node="false"
            :data="treeData"
            :props="defaultProps"
            :filter-node-method="filterNode"
            @node-click="handleTreeNode"
            :class="defaultClass"
        />
        <el-popover
            v-if="popover === true"
            placement="top-start"
            width="320"
            trigger="click"
            v-model="visible" 
            @after-enter='treeShow'>
            <el-input 
              placeholder="输入关键字进行过滤"
              v-model="filterText">
            </el-input>
            <el-tree
                v-if="!isRead"
                highlight-current
                :show-checkbox='multiple'
                node-key="id"
                ref="tree"
                :current-node-key="selectNodeId"
                :default-expanded-keys="idExpandedArr"
                :expand-on-click-node="false"
                :data="treeData"
                :props="defaultProps"
                :filter-node-method="filterNode"
                @node-click="handleTreeNode"
                :class="defaultClass"
            />
            <div v-if="!isRead" style="margin-top:10%" class="buttons">
              <el-button type="primary" @click="getCheckedKeys" v-if="multiple">确定</el-button>
              <el-button @click="resetChecked">清空</el-button>
            </div>
              <el-tooltip  slot="reference" :content="selectedContent" effect="light" placement="top">
                  <el-input  :disabled="isRead"  readonly v-model="popoverTreeLable"></el-input>
              </el-tooltip> 
        </el-popover>
    </div>
</template>

<script>
    import { getDictionaryTreeList, getCustomerDictionaryTreeList } from '@/data-model';
    import { isEmpty } from 'lodash';

    const dictionaryTreeCacheMap = new Map();
    const dictionaryTreePendingMap = new Map();
    const getDictionaryTreeCacheKey = (channelFlag, appId, rootId) => {
        return [channelFlag || '', appId || '', rootId || ''].join(':');
    };

    export default {
        name: 'DictionaryTree',
        data () {
            return {
                filterText: '',
                treeData: [],
                idExpandedArr: [],
                selectNodeId: 0,
                popoverTreeLable: '',
                selectedContent: '',
                multiSelectedNode: {
                    label: '',
                    idExpandedArr: []
                },
                visible: false,
                treeDataLoaded: false
            };
        },
        watch: {
            filterText (val) {
                this.$refs.tree.filter(val);
            }
        },
        props: {
            rootId: { // 获取节点树结构数据时的根节点id
                type: [ Number, String ]
            },
            data: { // 外部传入的树的结构数据，如果没有传，使用组件自己的接口获取数据
                type: Array
            },
            selectedNode: { // 默认选中的树节点对象
                type: Object
            },
            defaultProps: { // 默认字段名配置
                type: Object
            },
            popover: { // 是否为弹出树
                type: Boolean,
                default: false
            },
            multiple: { // 是否多选
                type: Boolean,
                default: false
            },
            channelFlag: { // 外部传入的渠道标识，默认是客户使用，US客户，CS客服
                type: String
            },
            appId: { // 外部传入的渠道标识，所属应用（客服系统过来用）
                type: String
            },
            isRead: {
                type: Boolean,
                default: false
            },
            defaultClass: {
                type: String,
                default: 'dictionary-tree'
            },
            field: {
                type: Object
            }
        },
        created () {
            if (this.popover) {
                this._setSelectedNode();
            } else {
                this._initPage();
            }
        },
        mounted () {
            if (this.popover) {
                this.schedulePreloadTreeData();
            }
        },
        methods: {
            schedulePreloadTreeData () {
                let preload = () => {
                    this._initPage();
                };
                if (window.requestIdleCallback) {
                    window.requestIdleCallback(preload);
                } else {
                    setTimeout(preload, 500);
                }
            },
            async _initPage () {
                if (this.treeDataLoaded) {
                    this._setSelectedNode();
                    return;
                }
                await this._getTreeData().then(val => {
                // 初始化默认展开到第二级
                    if (this.treeData && this.treeData.length > 0) {
                        this.idExpandedArr = [];
                        this.idExpandedArr.push(this.treeData[0].id);
                    }
                });
                this.treeDataLoaded = true;
                this._setSelectedNode();
            },
            async _getTreeData () {
                let dictionaryTreeList = [];
                if (this.data) {
                    dictionaryTreeList = this.data;
                } else {
                    let cacheKey = getDictionaryTreeCacheKey(this.channelFlag, this.appId, this.rootId);
                    if (dictionaryTreeCacheMap.has(cacheKey)) {
                        this.treeData = dictionaryTreeCacheMap.get(cacheKey);
                        return;
                    }
                    let requestPromise = dictionaryTreePendingMap.get(cacheKey);
                    if (!requestPromise) {
                        requestPromise = this.channelFlag === 'CS' ? getCustomerDictionaryTreeList(this.appId) : getDictionaryTreeList(this.rootId);
                        dictionaryTreePendingMap.set(cacheKey, requestPromise);
                    }
                    try {
                        dictionaryTreeList = await requestPromise;
                    } finally {
                        dictionaryTreePendingMap.delete(cacheKey);
                    }
                    dictionaryTreeCacheMap.set(cacheKey, dictionaryTreeList);
                }
                this.treeData = dictionaryTreeList;
            },
            _setSelectedNode () {
                if (this.selectedNode) {
                    this.popoverTreeLable = this.selectedNode.label;
                    this.selectNodeId = Number(this.selectedNode.id);
                    // this.$nextTick().then(() => {
                    //     this.$refs.tree.setCurrentKey(this.selectNodeId);
                    // });
                }
            },
            _refreshSelectedNode (node) {
                if (this.multiple) {
                    if (node && node.value) {
                        this.popoverTreeLable = node.title;
                        this.selectedContent = this.popoverTreeLable;
                        if (node.value.indexOf(',') !== -1) {
                            this.idExpandedArr = [];
                            this.idExpandedArr = node.value.split(',');
                            if (this.$refs.tree) {
                                this.$refs.tree.setCheckedKeys(this.idExpandedArr);
                            }
                            this.multiSelectedNode.label = node.title;
                            this.multiSelectedNode.idExpandedArr = this.idExpandedArr;
                        }
                    }
                } else {
                    if (node) {
                        this.popoverTreeLable = node.title;
                        this.selectedContent = this.popoverTreeLable;
                        if (node.value) {
                            this.selectNodeId = Number(node.value);
                            // this.$nextTick().then(() => {
                            //     this.$refs.tree.setCurrentKey(this.selectNodeId);
                            // });
                        }
                    }
                }
            },
            handleTreeNode (data, node, tree) {
                if (this.field && this.field.options.ext2) {
                    let ext2 = this.field.options.ext2;
                    let ext2Obj = JSON.parse(ext2);
                    if (ext2Obj.dictionaryTreeChooseSonNode) { // 只能选择子节点
                        if (data.children && data.children.length > 0) {
                            this.$message.error('当前字段配置只允许选择子节点，请选择子节点');
                        } else {
                            if (!this.multiple) {
                                this.popoverTreeLable = data.label;
                                this.selectedContent = this.popoverTreeLable;
                                this.selectNodeId = data.id;
                                this.$emit('nodeClick', data, node, tree);
                                this.visible = false;
                            }
                        }
                    } else if (ext2Obj.dictionaryTreeChooseParentNode) { // 只能选择父节点
                        if (!data.children || data.children.length === 0) {
                            this.$message.error('当前字段配置只允许选择父节点，请选择父节点');
                        } else {
                            if (!this.multiple) {
                                this.popoverTreeLable = data.label;
                                this.selectedContent = this.popoverTreeLable;
                                this.selectNodeId = data.id;
                                this.$emit('nodeClick', data, node, tree);
                                this.visible = false;
                            }
                        }
                    } else {
                        if (!this.multiple) {
                            this.popoverTreeLable = data.label;
                            this.selectedContent = this.popoverTreeLable;
                            this.selectNodeId = data.id;
                            this.$emit('nodeClick', data, node, tree);
                            this.visible = false;
                        }
                    }
                } else {
                    if (!this.multiple) {
                        this.popoverTreeLable = data.label;
                        this.selectedContent = this.popoverTreeLable;
                        this.selectNodeId = data.id;
                        this.$emit('nodeClick', data, node, tree);
                        this.visible = false;
                    }
                }
            },
            getCheckedKeys () {
                // console.log(this.$refs.tree.getCheckedKeys());
                let selectedIds = this.$refs.tree.getCheckedKeys();
                let selectedNames = [];
                let selectMap = new Map();
                selectedIds.find((item) => {
                    selectMap.set(item, item);
                });
                this.treeData.forEach(item => { // 递归查找子节点
                    if (selectMap.has(item.id)) {
                        selectedNames.push(item.label);
                    };
                    if (item.children) {
                        this.findChildrenNodes(item.children, selectMap, selectedNames);
                    }
                });
                // console.log(selectedIds);
                // console.log(selectedNames);
    
                let node = {selectedIds: '', selectedNames: ''};
                if (selectedIds) {
                    this.popoverTreeLable = selectedNames.join(',');
                    this.selectedContent = this.popoverTreeLable;
                    node.selectedIds = selectedIds.join(',');
                    node.selectedNames = this.popoverTreeLable;
                }
                this.$emit('nodeClick', node);
                this.visible = false;
            },
            findChildrenNodes (arr, selectMap, selectedNames) {
                arr.forEach((v, i) => {
                    if (selectMap.has(v.id)) {
                        selectedNames.push(v.label);
                    };
                    if (v.children) {
                        this.findChildrenNodes(v.children, selectMap, selectedNames);
                    }
                });
            },
            resetChecked () {
                // this.$refs.tree.setCheckedKeys([]);
                this.popoverTreeLable = '';
                this.selectedContent = this.popoverTreeLable;
                let node = {selectedIds: '', selectedNames: ''};
                this.multiSelectedNode = {
                    label: '',
                    idExpandedArr: []
                };
                this.idExpandedArr = [];
                this.$refs.tree.setCheckedKeys(this.idExpandedArr);
                this.$emit('nodeClick', node);
                this.visible = false;
            },
            setTreeStatus () {
                // this.$refs.tree.setCurrentNode(2);
                // console.log(this.selectNodeId);
                if (this.multiple) {
                    if (!isEmpty(this.multiSelectedNode.idExpandedArr)) {
                        this.idExpandedArr = this.multiSelectedNode.idExpandedArr;
                    }
                } else {
                    this.$nextTick().then(() => {
                        this.$refs.tree.setCurrentKey(this.selectNodeId);
                    });
                }
            },
            async treeShow () {
                await this._initPage();
                this.setTreeStatus();
                this.$emit('treeShow');
            },
            filterNode (value, data) {
                if (!value) return true;
                return data.label.indexOf(value) !== -1;
            }
        }
    };
</script>



// WEBPACK FOOTER //
// src/components/DictionaryTree/DictionaryTree.vue